import { colorblindSafeTicketGroupColors, ticketGroupColors } from '@tix/themes/helpers'

import { flags } from '@/helpers/ConfigCat'

import type { LinkedTG } from '@/api/types/processedEntities'

export function assignGroupColor(group: LinkedTG, index: number): void {
  group.color = 1 + index
}

/**
 * @TODO Always use `colorblindSafeTicketGroupColors` once `tg_seat_accessibility` flag is removed.
 * When removing: delete this function's conditional and always use `colorblindSafeTicketGroupColors`.
 */
export function getTicketGroupColor(group: LinkedTG): string | null {
  const colors = flags?.tg_seat_accessibility ? colorblindSafeTicketGroupColors : ticketGroupColors
  // Recycle the colors array if the group color is greater than the number of colors
  return group.color ? colors[(group.color - 1) % colors.length] : null
}
